import request from '../../shared/request'

export function getLeadsPerMonth() {
  return request(`/dashboard/leads-per-month`)
}

export function getLeadsStatusCountPerMonth() {
  return request(`/dashboard/leads-status-count-per-month`)
}

export function getDashboardFollowUps(params) {
  return request(`/dashboard/follow-ups/${params.userId}?show30d=${params.show30d}`)
}

export function updateLDashboardFollowUp(payload) {
  return request(`/dashboard/follow-ups/${payload.id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/dashboard.js